import { IDialogStyleProps, IDialogStyles } from '@fluentui/react';

export const DialogStyles = (_props: IDialogStyleProps): Partial<IDialogStyles> => {
    return {
        main: {
            colorScheme: 'dark',
        },
    };
};
